import { render, staticRenderFns } from "./ComponentSocial.vue?vue&type=template&id=794844e3&"
import script from "./ComponentSocial.vue?vue&type=script&lang=js&"
export * from "./ComponentSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sam/code/rzk-mode-landing-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('794844e3')) {
      api.createRecord('794844e3', component.options)
    } else {
      api.reload('794844e3', component.options)
    }
    module.hot.accept("./ComponentSocial.vue?vue&type=template&id=794844e3&", function () {
      api.rerender('794844e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ComponentSocial.vue"
export default component.exports